<div class="table-add-container">
  <div [id]="tourGuideIds.adminContent.tools.clickExpand.id" *ngIf="!flag" class="add-new-container">
    <mat-icon class="add" [id]="tourGuideIds.adminContent.tools.qgExpand.id" (click)="showData()"
      [matTooltip]="AddIcon">add</mat-icon>
    <mat-label class="add-row"></mat-label>
  </div>
  <div [id]="tourGuideIds.adminContent.tools.qgFields.id">
    <form [formGroup]="thresholdForm">
      <div *ngIf="flag" class="add-input-box">
        <div class="example-full-width">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" [placeholder]="Name" />
          </mat-form-field>

          <div class="error-text"
            *ngIf="thresholdForm.get('name')?.invalid && (thresholdForm.get('name')?.dirty || thresholdForm.get('name')?.touched)">
            <div *ngIf="thresholdForm.get('name')?.errors?.['required']">
              {{nameInput}}
            </div>
            <div *ngIf="thresholdForm.get('name')?.errors?.['duplicateName']">
              {{uniqueNameInput}}
            </div>
          </div>
        </div>

        <div class="example-full-width">
          <mat-form-field>
            <mat-label>Description</mat-label>

            <input matInput formControlName="description" [placeholder]="Desc" />
          </mat-form-field>

          <div class="error-text"
            *ngIf="thresholdForm.get('description')?.invalid && (thresholdForm.get('description')?.dirty || thresholdForm.get('description')?.touched)">
            <div *ngIf="thresholdForm.get('description')?.errors?.['required']">
              Description is required
            </div>
          </div>
        </div>

        <div class="example-full-width">
          <mat-form-field>
            <mat-label>Threshold</mat-label>
            <input matInput type="number" formControlName="threshold" [placeholder]="Threshold" />
          </mat-form-field>

          <div class="error-text"
            *ngIf="thresholdForm.get('threshold')?.invalid && (thresholdForm.get('threshold')?.dirty || thresholdForm.get('threshold')?.touched)">
            <div *ngIf="thresholdForm.get('threshold')?.errors?.['required']">
              Threshold is required
            </div>
            <div
              *ngIf="thresholdForm.get('threshold')?.errors?.['max'] || thresholdForm.get('threshold')?.errors?.['min']">
              Threshold value should be between 0 and 9999
            </div>
          </div>
        </div>

        <div class="icon-container" [ngClass]="{ 'disabled': !thresholdForm.valid }">
          <mat-icon (click)="saveData()" [id]="tourGuideIds.adminContent.tools.saveBtn.id"
            color="primary">save</mat-icon>
        </div>
        <div class="icon-container" [matTooltip]="cancelIcon" (click)="cancelData()">
          <mat-icon color="warn" [id]="tourGuideIds.adminContent.tools.cancelBtn.id">cancel</mat-icon>
        </div>
      </div>
    </form>
  </div>

  <div class="table-margin">
    <section class="fixed-header mat-elevation-z8" tabindex="0">
    <table [id]="tourGuideIds.adminContent.tools.qualityGatesTbl.id" mat-table [dataSource]="dataSource"
      class="mat-elevation-z8">
      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef>No</th>
        <td mat-cell *matCellDef="let element;let i=index">{{ i+1 }}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">{{ element.name}}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>

        <td mat-cell *matCellDef="let element">{{ element.description }}</td>
      </ng-container>

      <ng-container matColumnDef="threshold">
        <th mat-header-cell *matHeaderCellDef>Threshold</th>

        <td mat-cell *matCellDef="let element">{{ element.threshold }}</td>
      </ng-container>

      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <mat-icon color="primary" class="cursor" (click)="editRow(i)">edit</mat-icon>
          <mat-icon class="delete-icon cursor" color="warn" (click)="deleteRow(i,element)">delete</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <!-- No data available -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan=9>
          <app-no-data-available [newData]="getNoData"></app-no-data-available>
        </td>
      </tr>
    </table>
  </section>
  </div>
</div>